import React from "react";
import PropTypes from "prop-types";
import cname from "./style.module.scss";

import { RichText } from "@learningblocks/shared-components/lib/RichText";

export function Banner({ title, text, key, onClickHighlight }) {
  title = typeof title === "string" ? title : title.value;
  text = typeof text === "string" ? text : text.value;
  return (
    <>
      <div className={cname.title}>
        <h3>
          <RichText
            key={key}
            onClickHighlight={onClickHighlight}
            value={title}
          />
        </h3>
      </div>
      <div className={cname.text}>
        <p className="tag content_component">
          <RichText
            key={key}
            onClickHighlight={onClickHighlight}
            value={text}
          />
        </p>
      </div>
    </>
  );
}

Banner.propTypes = {
  /**
   * Title to display on top of banner
   */
  title: PropTypes.string,
  /**
   * Content to display in banner
   */
  text: PropTypes.string,
};

Banner.defaultProps = {
  title: "",
  text: "",
};
